module.exports = __webpack_public_path__ + "static/mary-kay-background-1da582e1f77a592509b731c7ffe4b8ce.jpg";